// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2V0ov","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2IvRA"};